import api from './api'

/** 发送手机验证码 — 与主站相同 */
export function sendPhoneCode(phone) {
  return api.post('/login/phone-code', { phone })
}

/** 发送邮箱验证码 — 与主站相同 */
export function sendEmailCode(email) {
  return api.post('/login/email-code', { email })
}

/** 手机验证码登录/注册 */
export function loginWithPhoneCode(phone, phone_code) {
  return api.post('/login/app/with-phone-code', { phone, phone_code })
}

/** 密码登录（手机 / 邮箱 / 账号） */
export function loginWithPassword(payload) {
  return api.post('/login/app/with-password', payload)
}

/** 邮箱验证码登录 */
export function loginWithEmailCode(email, email_code) {
  return api.post('/login/app/with-email-code', { email, email_code })
}

/** 当前用户 */
export function fetchCurrentUser() {
  return api.get('/user')
}
